import PropTypes from 'prop-types';
import { isValidElement } from 'react';

// material-ui
import { IconButton } from '@mui/material';
import { useGridSelector, useGridApiContext, gridDetailPanelExpandedRowsContentCacheSelector } from '@mui/x-data-grid-pro';

// assets
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

// =========================|| APP DATA GRID - MASTER DETAIL - TOGGLE PANEL ||========================= //

export const CustomDetailPanelToggle = ({ id, value: isExpanded }) => {
    const apiRef = useGridApiContext();
    const contentCache = useGridSelector(apiRef, gridDetailPanelExpandedRowsContentCacheSelector);
    const hasDetail = isValidElement(contentCache[id]);

    return (
        <IconButton size="small" tabIndex={-1} disabled={!hasDetail}>
            {isExpanded ? <KeyboardArrowDownIcon fontSize="small" /> : <KeyboardArrowRightIcon fontSize="small" />}
        </IconButton>
    );
};

CustomDetailPanelToggle.propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    value: PropTypes.bool
};

export default CustomDetailPanelToggle;
